<template>
  <div>
    <vueTopprogress 
      color="#4385f3" 
      color-shadow="transparent" 
      error-color="#fff" 
      ref="progress" ></vueTopprogress>
    <div 
      v-if="blocked" 
      class="blocker"></div>
  </div>
</template>

<style scoped>
.blocker {
  top: 0;
  position: fixed;
  height: 100%;
  width: 100%;
  cursor: wait;
  z-index: 9999999;
}
</style>

<script>
import ProgressBar from "./progressBar.ts";
export default ProgressBar;
</script>
